import {createLogger as reduxLogger} from 'redux-logger';

export default function createLogger() {
  return reduxLogger({
    predicate: (getState, action) =>( !action.type.includes('APOLLO') && !action.type.includes('@@redux-form')),

    collapsed: true,
  });
}
